import * as React from 'react'
import { SVGProps } from 'react'
const SvgMenuRight = (props: SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
		<path fill="currentColor" d="m10 17 5-5-5-5v10Z" />
	</svg>
)
export default SvgMenuRight
